import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { useQuery } from 'react-query';
import { dashboardApi } from '../../../../../api/dashboard';
import { ScaleLoader } from 'react-spinners';

const COLORS = {
  'Not Started': '#94a3b8',
  'In Progress': '#f97316',
  'Completed': '#22c55e',
};

const LearnerStatusChart = () => {
  const { data: learnerStatus, isLoading } = useQuery(
    ['admin-dashboard-learner-status'],
    () => dashboardApi.getLearnerStatus(),
    {
      cacheTime: 300000,
      staleTime: 300000,
      refetchOnWindowFocus: false,
      select: (res) => res?.data,
    }
  );

  // Map API response to chart format, falling back to empty array
  const chartData = learnerStatus
    ? Object.entries(learnerStatus).map(([key, value]) => {
        const label = key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (s) => s.toUpperCase())
          .trim();
        return {
          id: label,
          label,
          value: value ?? 0,
          color: COLORS[label] ?? '#6366f1',
        };
      })
    : [];

  return (
    <div className="bg-white p-6 shadow rounded-lg w-full h-[350px] relative">
      <h3 className="text-[15px] font-semibold text-gray-800">Learner Status</h3>

      {isLoading ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <ScaleLoader color="#0A3059" height={30} />
        </div>
      ) : (
        <>
          {/* Chart centered in the remaining space */}
          <div className="absolute inset-0 top-12 bottom-28">
            <ResponsivePie
              data={chartData}
              margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
              innerRadius={0.65}
              padAngle={0.5}
              cornerRadius={0}
              activeOuterRadiusOffset={4}
              colors={{ datum: 'data.color' }}
              borderWidth={0}
              enableArcLinkLabels={false}
              enableArcLabels={false}
              tooltip={({ datum: { id, value, color } }) => (
                <div className="bg-white p-2 shadow rounded text-xs flex items-center gap-2">
                  <div style={{ backgroundColor: color }} className="w-3 h-3 rounded-full" />
                  <strong>{id}:</strong> {value}
                </div>
              )}
            />
          </div>

          {/* Legend fixed to the bottom */}
          <div className="absolute bottom-6 left-6 right-6 flex flex-col gap-1.5">
            {chartData.map(item => (
              <div key={item.id} className="flex justify-between items-center text-[13px]">
                <div className="flex items-center gap-2">
                  <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.color }} />
                  <span className="text-gray-500 font-medium">{item.label}</span>
                </div>
                <span className="font-bold text-gray-800">{item.value}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LearnerStatusChart;
